/** Public contact & social URLs (from `.env` / `REACT_APP_*`). */

export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'contacto@neodrive.app';

export const WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || '+351111111111';

export const FACEBOOK_URL =
  process.env.REACT_APP_FACEBOOK_URL ||
  'https://www.facebook.com/profile.php?id=111111111111111';

export const INSTAGRAM_URL =
  process.env.REACT_APP_INSTAGRAM_URL ||
  'https://www.instagram.com/neodrive.app?igsh=111111111111111';

export function whatsAppHref(e164: string): string {
  const digits = e164.replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}` : '#';
}
